function PubFilter(form, actions, items, pagination, searchCounter=[]) {
    var self = this;
    this.form = form;
    this.items = items;
    this.pagination = pagination;
    this.searchCounter = searchCounter;
    this.state = {};
    this.form.on('submit', function (e) {
        e.preventDefault();
        var url = '?' + $(this).serialize();
        console.log(this)
        self.render(url);
    });

    const sort = $(actions).find('.js-sort')[0]
    if (sort && this.form.find('input[name=sort]')) new Sort(sort, this.form);
    this.form.find('input').each(function () {
        try {
            self.state[this.name] = JSON.parse(this.value);
        } catch (e) {
            self.state[this.name] = null;
        }
    });
    this.actions = new FilterActions(actions.find('a'), function (el) {
        const { year, week } = getYearAndWeekNumber(new Date())
        if (el.el.dataset.clearWeekYear) {
            self.setState('calendar', null);
            self.setState('week', week);
            self.setState('year', year);
        }
        self.setState(el.name, null);
        self.form.submit();
    });
    this.actions.setData(this.state);
    this.actions.render();
    this.handlePagination();
}

PubFilter.prototype.render = function (url) {
    var self = this;
    $.post(url, function (resp) {
        if (resp.success) {
            self.pagination.html(resp.paginator);
            self.items.html(resp.items);
            if (self.searchCounter.length) {
                self.searchCounter.html(resp.count_view)
            }
            self.handlePagination();
            window.history.replaceState({}, document.title, url);
        } else {
            alert('Произошла ошибка');
        }
    });
};

PubFilter.prototype.handlePagination = function () {
    var self = this;
    $('.js-pagination .pagination__link, .js-pagination .ievent__interval-href')
        .on('click', function (e) {
            e.preventDefault();

            const pagination = e.target.closest('.js-pagination')
            if (!$(pagination).hasClass('js-pagination-disable-scroll')) {
                $('html, body').animate({ scrollTop: 0 },500);
            }

            self.render(this.href);
        })
};

PubFilter.prototype.setState = function (name, value) {
    this.state[name] = value;
    this.form.find('input[name=' + name + ']').val(JSON.stringify(value));
    this.actions.setData(this.state);
};

